const LoadingCounter = ({ width = "50px", className }) => {
    return (
        <div className={className + " h-screen flex items-center justify-center"}>
            <div
                className="flex justify-between items-center"
                style={{ width }}
            >
                <span className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-pulse [animation-duration:1s]" />
                <span className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-pulse [animation-duration:1.1s]" />
                <span className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-pulse [animation-duration:1.2s]" />
            </div>
        </div>

    );
};

export default LoadingCounter;